import { render, staticRenderFns } from "./comp15.vue?vue&type=template&id=3c44c416&scoped=true"
import script from "./comp15.vue?vue&type=script&lang=ts"
export * from "./comp15.vue?vue&type=script&lang=ts"
import style0 from "./comp15.vue?vue&type=style&index=0&id=3c44c416&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c44c416",
  null
  
)

export default component.exports